<script>
  import MapGroup from '../Objects/MapGroup.vue'
  import MapObject from '../Objects/MapObject.vue'

  export default {
    components: { MapGroup, MapObject },
    props: {
      delay: { type: [Number, Boolean], default: true },
      area: { type: Boolean, default: false },
    },
    data () {
      return { ready: false }
    },
    mounted () {
      let delay = 0

      if (this.delay === true) {
        const duration = this.$store.state.durations.reduce((acc, value) => (acc + value), 0)
        delay = duration - 1500
        delay = delay > 0 ? delay : 0
      } else {
        delay = Number(this.delay)
      }
      setTimeout(() => (this.ready = true), delay)
    },
    computed: {
      classList () {
        return {
          'map-scene': true,
          'map-scene--area': this.area,
          'map-scene--animated': this.ready
        }
      }
    }
  }
</script>

<style lang="scss">
  .map-scene {
    position: absolute;

    &.map-scene--area {
      background: rgba(#fff, 0.35);
    }
  }
</style>
